import React, { Fragment } from "react";
import { Typography, Box, Button, Link, Grid } from "@material-ui/core";
import { useStyles } from "../Theme.js";

const PolitiqueConfidentialite = () => {
  const classes = useStyles();
  return (
    <Fragment>
      <Box
        className={classes.subHeader}
        style={{
          marginTop: 20,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: "0",
        }}
      >
        <Typography
          variant="h3"
          className={classes.subHeaderTitle}
          style={{ textAlign: "center", display: "block" }}
        >
          Politique de Confidentialite
        </Typography>
      </Box>
      <Typography variant="body2" style={{ padding: "0 30px" }}>
        <p>
          Le Conseil Départemental de l’Ariège est soucieux de la protection de
          vos données personnelles. Elle s’engage à assurer le meilleur niveau
          de protection à vos données personnelles collectées, en conformité
          avec les réglementations européennes et française qui lui sont
          applicables. Pour toute information sur la protection des données
          personnelles, vous pouvez également consulter le site de la Commission
          Nationale Informatique et Liberté :{" "}
          <a href="http://www.cnil.fr/" target="_blank" rel="noreferrer">
            http://www.cnil.fr/
          </a>
        </p>
        <p>
          Le responsable de traitement est M. XXX en sa qualité de XXX de le
          Conseil Départemental de l’Ariège.
        </p>
        <p>
          Les données vous concernant sont traitées par le Conseil Départemental
          de l’Ariège. Ces traitements peuvent être fondés sur différentes bases
          légales en fonction des finalités concernées.
        </p>
        <p>
          Nous collectons et traitons notamment vos nom, prénom, adresse,
          adresse email, numéro de téléphone, mot de passe (lié à l’utilisation
          de notre site), adresse IP, données de connexions et données de
          navigation. Dans certains cas, nous pouvons collecter des données de
          localisation par exemple pour vous indiquer le magasin le plus proche
          de chez vous.
          <br />
          Le caractère obligatoire ou facultatif des données vous est signalé
          lors de la collecte par un astérisque. Certaines données sont
          collectées automatiquement du fait de vos actions sur le site.
        </p>
        <p>
          Les données que nous collectons peuvent être transmises aux
          prestataires (sous-traitants) auxquels Le Conseil Départemental de
          l’Ariègefait appel pour la réalisation de ses services, dans le cadre
          des finalités mentionnées, par exemple pour la gestion, l’exécution,
          le traitement.
        </p>

        <p>
          Vous pouvez contacter le Délégué à la Protection des Données Le
          Conseil Départemental de l’Ariègeà l'adresse contact@nattur.eu ou par
          courrier à l'adresse suivante : Hôtel du Département 5-7 rue du Cap de
          la Ville 09001 FOIX Cedex{" "}
        </p>

        <p>
          Vous disposez par ailleurs, du droit d’introduire une réclamation
          auprès de la Commission Nationale de l’Informatique et des Libertés
          (CNIL), notamment sur son site internet{" "}
          <a href="http://www.cnil.fr/" target="_blank" rel="noreferrer">
            http://www.cnil.fr/
          </a>
          .
        </p>
        <p>
          Les données vous concernant seront conservées pendant une durée de 3
          ans à compter de votre dernière activité (ex : achat ou échéance de
          vos contrats) puis archivées avec un accès restreint pour une durée
          supplémentaire de 3 ans pour des raisons strictement limitées et
          autorisées par la loi (paiement, garantie, litiges …). Vous êtes
          informés que vos données peuvent être transmises pour les besoins des
          finalités mentionnées ci-avant à des sociétés situées en dehors de
          l’Union Européenne notamment pour les activités de service client,
          prestations informatiques, exploitation des données en lien avec les
          réseaux sociaux. Toute procédure requise pour sécuriser les données
          sera mise en œuvre avant de procéder à de tels transferts.
        </p>
      </Typography>
    </Fragment>
  );
};

export default PolitiqueConfidentialite;
